/* Film Slayers theme behaviour: header shrink, mobile nav, reveal on scroll. */
(function () {
  var header = document.querySelector('.fs-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-shrunk', window.scrollY > 30); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var toggle = document.getElementById('fsNavToggle');
  var nav = document.getElementById('fsNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('fs-nav-open', open);
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('open'); toggle.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('fs-nav-open');
      });
    });
  }

  /* Reveal. Force-show after 1.5s so nothing can ever stay hidden. */
  var els = document.querySelectorAll('.fs-section-head, .fs-card, .fs-band-inner, .fs-austin-text, .fs-austin-media, .fs-news-inner, .fs-trust-item');
  var showAll = function () { els.forEach(function (el) { el.classList.add('in'); }); };
  if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
    els.forEach(function (el) { el.classList.add('fs-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(showAll, 1500);
  }
})();
